var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { styled } from 'styled-components';
import { AddClassAccordion, FirstRunAccordion, StudentsPasswordsAccordion, StudentsSignInAccordion, } from './Accordions';
import { PROGRESS_STEPS_ORDER } from '../../../constants/progress';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-15lk7ov" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & > :not(:last-child) {\n    margin-bottom: 16px;\n  }\n"], ["\n  & > :not(:last-child) {\n    margin-bottom: 16px;\n  }\n"])));
var AccordionList = function (_a) {
    var data = _a.data, onPasswordOpen = _a.onPasswordOpen, onPlayVideo = _a.onPlayVideo, progress = _a.progress, rest = __rest(_a, ["data", "onPasswordOpen", "onPlayVideo", "progress"]);
    var groupInfo = data.groupInfo, students = data.students, studentsRateTarget = data.studentsRateTarget, yearlyDashboardLink = data.yearlyDashboardLink, weeklyDashboardLink = data.weeklyDashboardLink;
    var currentProgress = React.useMemo(function () {
        return PROGRESS_STEPS_ORDER.find(function (step) { return !progress[step]; });
    }, [progress]);
    var Steps = React.useMemo(function () { return ({
        add_group: function (props) { return (_jsx(AddClassAccordion, __assign({}, props, { groupInfo: groupInfo }), void 0)); },
        provide_passwords: function (props) { return (_jsx(StudentsPasswordsAccordion, __assign({}, props, { groupInfo: groupInfo, students: students, onOpen: onPasswordOpen }), void 0)); },
        login_students: function (props) { return (_jsx(StudentsSignInAccordion, __assign({}, props, { students: students, studentsRateTarget: studentsRateTarget }), void 0)); },
        first_run: function (props) { return (_jsx(FirstRunAccordion, __assign({}, props, { onPlayVideo: onPlayVideo, studentsRateTarget: studentsRateTarget, yearlyDashboardLink: yearlyDashboardLink, weeklyDashboardLink: weeklyDashboardLink, grade: groupInfo.grade, placementTestAvailable: groupInfo.placementTestAvailable }), void 0)); },
    }); }, [
        groupInfo,
        students,
        studentsRateTarget,
        yearlyDashboardLink,
        weeklyDashboardLink,
        onPasswordOpen,
        onPlayVideo,
    ]);
    return (_jsx(Container, __assign({}, rest, { "data-testid": 'accordion-list' }, { children: PROGRESS_STEPS_ORDER.map(function (step) {
            var Component = Steps[step];
            return (_jsx(Component, { checked: progress[step], opened: currentProgress === step }, step));
        }) }), void 0));
};
export { AccordionList };
var templateObject_1;
